const collapseWhitespace = (value: string): string => value.replace(/\s+/g, ' ').trim();

/**
 * Builds a boat's display name from its year, manufacturer and model.
 *
 * Assembled from a filtered array rather than by concatenation, so a missing field drops out
 * instead of leaving a stray separator or a literal "null" in the output.
 */
export const getBoatName = (boat: {
  yearFirst?: number | null;
  model?: string | null;
  manufacturer?: {
    name?: string;
  };
}): string => {
  const year = boat?.yearFirst?.toString();
  const manufacturer = collapseWhitespace(boat?.manufacturer?.name ?? '');
  const model = collapseWhitespace(boat?.model ?? '');

  // Many models are catalogued with the maker already in the name ("Hobie Cat" + "Hobie Cat Bravo").
  // Emitting both reads as a stutter, so the standalone manufacturer is dropped in that case.
  const modelRepeatsManufacturer =
    manufacturer.length > 0 && model.toLowerCase().startsWith(manufacturer.toLowerCase());

  return [year, modelRepeatsManufacturer ? '' : manufacturer, model].filter(Boolean).join(' ');
};
